import Konva from "konva";
import { Util } from 'konva/lib/Util';
import _Text from "./_Text";
import _Image from "./_Image";
import _TextPath from "./_TextPath";
import TextJSON from "../TextJSON";
export default class _Node extends Konva.Node {
    constructor(json, container) {
        super(json, container);
        this.className = 'Node';
    }
    
    static _createNode(obj, container) {
        let className = Konva._Node.prototype.getClassName.call(obj), children = obj.children, no, len, n;
        const _customObjects = ['Text', 'TextPath'];

        if (container) {
            obj.attrs.container = container;
        }

        if (_customObjects.includes(className)) {
            className = '_' + className;
        }

        if (!Konva[className]) {
            Util.warn('Can not find a node with class name "' +
                className +
                '". Fallback to "Shape".');
            className = 'Shape';
        }
        const Class = Konva[className];
        no = new Class(obj.attrs, TextJSON);

        if (children) {
            len = children.length;
            for (n = 0; n < len; n++) {
                no.add(Konva._Node._createNode(children[n], null));
            }
        }

        return no;
    }
}

Konva._Node = _Node;